import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig, profile, concepts } from 'config/config'; // Importing configuration settings

/**
 * Class representing the view for other expenses.
 */
export default class otherExpensesView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The layout configuration.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const vthis = this; // Reference to the current instance
        const data = []; // Initial data array

        // Extending webix DataDriver to customize JSON handling
        webix.DataDriver.myjson = webix.extend(
            {
                toObject: function (arr) {
                    arr = webix.DataDriver.json.toObject(arr); // Convert JSON to object
                    for (var i = 0; i < arr.length; i++) {
                        arr[i].id = arr[i].Name; // Set id to Name property
                    }
                    return arr; // Return modified array
                },
            },
            webix.DataDriver.json,
        );

        // Creating a new data collection for concepts
        var newConceptList = new webix.DataCollection({
            data: concepts,
            datatype: 'myjson',
        });

        let totalExpenses = 0; // Variable to hold total expenses
        totalExpenses = data
            .map((item) => item.Value) // Extracting Value from data
            .reduce((prev, curr) => prev + curr, 0); // Summing up the values

        // Configuration for the first data table (grid1)
        var grid1 = {
            rows: [
                {
                    view: 'datatable',
                    id: 'grid1', // Unique identifier for the grid
                    css: 'webix_header_border webix_data_border auditreview_style', // CSS classes for styling
                    autoheight: true, // Automatically adjust height
                    columns: [
                        {
                            id: 'detailTittle',
                            header: '',
                            width: 50,
                            height: 25,
                            tooltip: _('Detalles'), // Tooltip for details
                            template: function (obj) {
                                return ''; // Template for detail column
                            },
                        },
                        {
                            id: 'Description',
                            header: {
                                text: 'Descripción',
                                css: { 'text-align': 'center' }, // Centered header text
                            },
                            width: 200,
                        },
                        {
                            id: 'Reference',
                            header: {
                                text: 'Referencia',
                                css: { 'text-align': 'center' }, // Centered header text
                            },
                            width: 120,
                        },
                        {
                            id: 'Concept',
                            header: {
                                text: 'Concepto',
                                css: { 'text-align': 'center' }, // Centered header text
                            },
                            width: 120,
                        },
                        {
                            id: 'Value',
                            header: {
                                text: 'Valor',
                                css: { 'text-align': 'center' }, // Centered header text
                            },
                            fillspace: true, // Fill remaining space
                        },
                    ],
                    data: data, // Initial data for the grid
                },
            ],
        };

        /**
         * Updates the sum of values in grid2.
         * @returns {number} The calculated sum.
         */
        function updateSumm() {
            var summ = 0; // Initialize sum
            $$('grid2').data.each(function (row) {
                summ += row.Value * 1 || 0; // Accumulate values
            });
            return summ; // Return the total sum
        }

        const data2 = []; // Initial data array for grid2

        /**
         * Checks if a value is not empty.
         * @param {string} value - The value to check.
         * @returns {boolean} True if not empty, false otherwise.
         */
        function notEmpty(value) {
            return value != ''; // Return true if value is not empty
        }

        /**
         * Checks if a value is a positive integer.
         * @param {number} value - The value to check.
         * @returns {boolean} True if positive, false otherwise.
         */
        function positiveInteger(value) {
            return value > 0; // Return true if value is greater than 0
        }

        // Configuration for the second data table (grid2)
        var grid2 = {
            rows: [
                {
                    view: 'datatable',
                    autoConfig: true, // Automatically configure columns
                    data: data2, // Initial data for the grid
                    id: 'grid2', // Unique identifier for the grid
                    select: 'row', // Row selection mode
                    editable: true, // Enable editing
                    css: 'webix_header_border webix_data_border auditreview_style', // CSS classes for styling
                    columns: [
                        {
                            id: 'detailTittle',
                            header: '',
                            width: 50,
                            height: 25,
                            tooltip: _('Detalles'), // Tooltip for details
                            template: function (obj) {
                                return "<span class='webix_icon wxi-close torefuse'></span>"; // Close icon template
                            },
                        },
                        { id: 'Description', editor: 'text', width: 200 }, // Editable Description column
                        { id: 'Reference', editor: 'text', width: 120 }, // Editable Reference column
                        {
                            id: 'Concept',
                            width: 120,
                            sort: 'text', // Sort by text
                            editor: 'combo', // Combo editor for selection
                            options: concepts, // Options for the combo
                            template: function (obj) {
                                return obj.Concept; // Display Concept
                            },
                            suggest: {
                                template: '#value#', // Suggestion template
                                filter: function (item, Value) {
                                    if (item.value.toString().toLowerCase().indexOf(Value.toLowerCase()) === 0)
                                        return true; // Filter suggestions
                                    return false;
                                },
                                body: {
                                    template: '#value#', // Template for suggestion body
                                    yCount: 7, // Number of visible suggestions
                                    on: {
                                        onItemClick: function (id) {}, // Click event for suggestions
                                    },
                                },
                            },
                        },
                        { id: 'Value', editor: 'text', fillspace: true }, // Editable Value column
                    ],
                    onClick: {
                        torefuse: function (euv, id) {
                            $$('grid2').remove($$('grid2').getSelectedId()); // Remove selected row
                        },
                    },
                    header: false, // No header
                    rules: {
                        Description: notEmpty, // Validation rule for Description
                        Concept: notEmpty, // Validation rule for Concept
                        Value: positiveInteger, // Validation rule for Value
                    },
                    ready: function () {
                        this.validate(); // Validate the grid on ready
                    },
                },
                {
                    view: 'text',
                    label: 'Total Egresos', // Label for total expenses
                    labelWidth: 100,
                    value: totalExpenses, // Initial total expenses value
                    readonly: true, // Make it read-only
                    id: 'summ', // Unique identifier for total expenses
                },
                {
                    cols: [
                        {
                            view: 'button',
                            label: 'Añadir Egreso', // Button label
                            click: function () {
                                var data = {}; // New data object
                                $$('grid2').editStop(); // Stop editing
                                var id = $$('grid2').add(data, 1000000); // Add new row
                                $$('grid2').editRow(id); // Edit the new row
                            },
                        },
                    ],
                },
            ],
        };

        // Event listener for updating the total expenses
        this.on(this.app, 'updateSumm', (sum) => {
            var total = totalExpenses + updateSumm(); // Calculate new total
            $$('summ').setValue(total); // Update total display
            vthis.app.callEvent('totalExpenses:sum', [{ total }]); // Trigger total expenses event
        });

        return {
            rows: [grid1, grid2], // Return the layout with both grids
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        var vthis = this; // Reference to the current instance
        $$('grid2').data.attachEvent('onStoreUpdated', function (id, obj, mode) {
            if (mode == 'add' || mode == 'update' || mode == 'delete') {
                if ($$('grid2').validate()) {
                    // Validate grid data
                    vthis.app.callEvent('updateSumm', [{}]); // Update total expenses
                    vthis.app.callEvent('expensesObject', [{}]); // Trigger expenses object event
                }
            }
        });

        // Delay to ensure the updateSumm event is called after a short period
        webix.delay(
            function () {
                vthis.app.callEvent('updateSumm', [{}]); // Call updateSumm event
            },
            '',
            '',
            100,
        );

        // AJAX request to fetch today's expenses
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json', // Set content type for the request
            })
            .post(devConfig.geturlApi() + 'Accounting/GetExpensesToday', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Display error message
                },
                success: function (text, data, XmlHttpRequest) {
                    var resp = JSON.parse(text); // Parse the response
                    $$('grid1').define('data', resp.Data); // Define data for grid1
                },
            });
    }
}

// FILE DOCUMENTED
